import { LOGO_URL, CONTACT, BOOKING_URL } from "@/lib/constants";
import { Mail, Phone, Globe, ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative section-dark border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <img
              src={LOGO_URL}
              alt="Tariff Refund Agency"
              className="h-12 w-auto"
            />
            <p className="mt-6 text-white/70 max-w-md leading-relaxed">
              IEEPA tariff recovery for U.S. importers. Zero upfront cost. 20%
              only on recovery. If we don&apos;t win, you owe nothing.
            </p>
            <motion.a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-cta"
              whileHover={{ x: 4 }}
              className="mt-8 inline-flex items-center gap-3 font-serif italic text-[#F5B800] text-2xl border-b border-[#F5B800]/50 hover:border-[#F5B800] pb-1"
            >
              Book your free assessment
              <ArrowUpRight size={22} />
            </motion.a>
          </div>

          <div className="lg:col-span-4">
            <div className="font-mono uppercase tracking-[0.24em] text-[11px] text-[#F5B800] mb-6">
              Contact
            </div>
            <ul className="space-y-4 text-white/80">
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-[#F5B800] shrink-0" />
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="footer-contact-email"
                  className="hover:text-[#F5B800] transition-colors"
                >
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-[#F5B800] shrink-0" />
                <a
                  href={CONTACT.phoneHref}
                  data-testid="footer-contact-phone"
                  className="hover:text-[#F5B800] transition-colors"
                >
                  {CONTACT.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Globe size={16} className="text-[#F5B800] shrink-0" />
                <a
                  href={CONTACT.websiteHref}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-contact-website"
                  className="hover:text-[#F5B800] transition-colors"
                >
                  {CONTACT.website}
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono uppercase tracking-[0.24em] text-[11px] text-[#F5B800] mb-6">
              Services
            </div>
            <ul className="space-y-3 text-white/80">
              <li>
                <a
                  href="#services"
                  className="hover:text-[#F5B800] transition-colors"
                >
                  Contingency Recovery
                </a>
              </li>
              <li>
                <a
                  href="#advance-funding"
                  className="hover:text-[#F5B800] transition-colors"
                >
                  Advance Funding
                </a>
              </li>
              <li>
                <a
                  href="#referral"
                  className="hover:text-[#F5B800] transition-colors"
                >
                  Referral Program
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-white/50 text-xs">
          <div>
            © {new Date().getFullYear()} Tariff Refund Agency. All rights
            reserved.
          </div>
          <div className="font-mono uppercase tracking-[0.2em]">
            IEEPA Tariff Recovery · Est. 2026
          </div>
        </div>
      </div>
    </footer>
  );
}
